import ReferralScreen from './Referral'

export default ReferralScreen
